import React from 'react';
import { Info, CheckCircle2, AlertTriangle, XCircle, X } from 'lucide-react';
import { cn } from './cn';

/**
 * Alert — thông báo nội dung (không phải toast). variant: brand|success|danger|warning.
 */
const VARIANTS = {
  brand: {
    box: 'bg-brand-softer border-indigo-200 text-brand-fg-strong dark:border-indigo-900',
    icon: 'text-brand-fg',
    Icon: Info,
  },
  success: {
    box: 'bg-emerald-50 border-emerald-200 text-emerald-800 dark:bg-emerald-950 dark:border-emerald-900 dark:text-emerald-200',
    icon: 'text-emerald-600 dark:text-emerald-400',
    Icon: CheckCircle2,
  },
  danger: {
    box: 'bg-red-50 border-red-200 text-red-800 dark:bg-red-950 dark:border-red-900 dark:text-red-200',
    icon: 'text-red-600 dark:text-red-400',
    Icon: XCircle,
  },
  warning: {
    box: 'bg-amber-50 border-amber-200 text-amber-800 dark:bg-amber-950 dark:border-amber-900 dark:text-amber-200',
    icon: 'text-amber-600 dark:text-amber-400',
    Icon: AlertTriangle,
  },
};

export function Alert({ variant = 'brand', title, children, onClose, icon: IconOverride, className, ...props }) {
  const v = VARIANTS[variant] || VARIANTS.brand;
  const Icon = IconOverride || v.Icon;
  return (
    <div role="alert" className={cn('flex gap-3 rounded-xl border p-4', v.box, className)} {...props}>
      <Icon className={cn('w-5 h-5 flex-shrink-0 mt-0.5', v.icon)} aria-hidden="true" />
      <div className="flex-1 min-w-0">
        {title ? <p className="text-base font-medium leading-snug">{title}</p> : null}
        {children ? <div className={cn('text-sm leading-relaxed', title && 'mt-1')}>{children}</div> : null}
      </div>
      {onClose ? (
        <button
          type="button"
          onClick={onClose}
          aria-label="Đóng"
          className="flex-shrink-0 rounded p-1 hover:bg-black/5 dark:hover:bg-white/10"
        >
          <X className="w-4 h-4" />
        </button>
      ) : null}
    </div>
  );
}

export default Alert;
